import createLoadingSlice from "./loading";
import { LoadingSlice } from "./loading.types";

export type { LoadingSlice };
export default createLoadingSlice;
